import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FormSelectInput } from "form";
import { ACTION_STATUS, TASKS } from "constants/actions";
import { useActionChoices } from "stores";
import { useFormikContext } from "formik";
import { useTaskOptions } from "./useTaskOptions";

const TaskSelectInput = ({
  selectedField,
  isViewMode,
  isBioCrop: bioOverride,
}) => {
  const { t } = useTranslation();
  const { getActionById } = useActionChoices();
  const { setValues, handleChange } = useFormikContext();
  const isBioCrop =
    typeof bioOverride === "boolean"
      ? bioOverride
      : Boolean(selectedField?.isBioCrop);

  const taskOptions = useTaskOptions();

  const changeAction = useCallback(
    (taskId) => {
      const action = getActionById(taskId);
      switch (action) {
        case TASKS.watering:
          setValues((prev) => ({
            ...prev,
            waterAction: {
              operationTypeId: selectedField?.wateringMechanismRead?.id,
              quantity: "0",
              quantityUnits: "liter",
            },
            fertilizeAction: undefined,
            drugAction: undefined,
            otherAction: undefined,
            diagnoseAction: undefined,
            observationAction: undefined,
          }));
          break;
        case TASKS.drug:
          setValues((prev) => ({
            ...prev,
            drugAction: { bio: isBioCrop, quantityUnits: "" },
            waterAction: undefined,
            fertilizeAction: undefined,
            otherAction: undefined,
            diagnoseAction: undefined,
            observationAction: undefined,
          }));
          break;
        case TASKS.fertilize:
          setValues((prev) => ({
            ...prev,
            fertilizeAction: { bio: isBioCrop },
            waterAction: undefined,
            drugAction: undefined,
            otherAction: undefined,
            diagnoseAction: undefined,
            observationAction: undefined,
          }));
          break;
        case TASKS.diagnose:
          setValues((prev) => ({
            ...prev,
            diagnoseAction: { operationTypeId: "" },
            waterAction: undefined,
            drugAction: undefined,
            otherAction: undefined,
            fertilizeAction: undefined,
            observationAction: undefined,
            attachments: [],
          }));
          break;
        case TASKS.other:
          setValues((prev) => ({
            ...prev,
            otherAction: { operationTypeId: "", description: "" },
            waterAction: undefined,
            drugAction: undefined,
            diagnoseAction: undefined,
            fertilizeAction: undefined,
            observationAction: undefined,
          }));
          break;
        case TASKS.observation:
          setValues((prev) => ({
            ...prev,
            observationAction: {
              description: "",
            },
            waterAction: undefined,
            drugAction: undefined,
            diagnoseAction: undefined,
            fertilizeAction: undefined,
            otherAction: undefined,
            attachments: [],
            status: ACTION_STATUS.performed,
          }));
          break;
        default:
          break;
      }
    },
    [getActionById, selectedField, setValues, isBioCrop],
  );

  const handleTaskChange = useCallback(
    (e) => {
      // It has to be in that order in order for both updates to take place
      changeAction(e.target.value);
      handleChange(e);
    },
    [changeAction, handleChange],
  );

  return (
    <FormSelectInput
      name="taskId"
      placeholder={t("ActionModal.ActionKind")}
      shouldHaveErrorBehaviorAfterSubmit
      isViewMode={isViewMode}
      onChange={handleTaskChange}
      options={taskOptions}
    />
  );
};

export default TaskSelectInput;
